(function () {
  const TRACK_SELECTOR =
    '.shipping-marquee-inline__track--animated, .shipping-marquee-banner__track--animated';

  function getGroupSelector(track) {
    return track.classList.contains('shipping-marquee-inline__track')
      ? '.shipping-marquee-inline__group'
      : '.shipping-marquee-banner__group';
  }

  function getItemSelector(track) {
    return track.classList.contains('shipping-marquee-inline__track')
      ? '.shipping-marquee-inline__item'
      : '.shipping-marquee-banner__item';
  }

  function fillGroup(group, barWidth, itemSelector) {
    const templateItem = group.querySelector(itemSelector);
    if (!templateItem || !barWidth) return;

    let guard = 0;
    while (group.scrollWidth < barWidth + templateItem.scrollWidth && guard < 48) {
      group.appendChild(templateItem.cloneNode(true));
      guard += 1;
    }
  }

  function syncMarqueeTrack(track, { force = false } = {}) {
    if (!track) return false;

    const bar = track.closest('.shipping-marquee-inline__bar, .shipping-marquee-banner__bar');
    if (!bar || !bar.clientWidth) return false;

    const groupSelector = getGroupSelector(track);
    const itemSelector = getItemSelector(track);
    const groups = [...track.querySelectorAll(groupSelector)];

    if (groups.length < 2) return false;

    if (!track.dataset.marqueeSourceHtml) {
      track.dataset.marqueeSourceHtml = groups[0].innerHTML;
    }

    const existingWidth = parseFloat(track.style.getPropertyValue('--marquee-group-width')) || 0;

    if (track.dataset.marqueeInitialized === 'true' && !force) {
      const currentGroupWidth = groups[0].scrollWidth;
      if (currentGroupWidth > 0 && Math.abs(currentGroupWidth - existingWidth) < 2) {
        return true;
      }
    }

    groups[0].innerHTML = track.dataset.marqueeSourceHtml;
    fillGroup(groups[0], bar.clientWidth, itemSelector);
    groups[1].innerHTML = groups[0].innerHTML;
    groups[1].setAttribute('aria-hidden', 'true');

    const groupWidth = groups[0].scrollWidth;
    if (!groupWidth) return false;

    track.style.setProperty('--marquee-group-width', `${groupWidth}px`);
    track.dataset.marqueeInitialized = 'true';
    return true;
  }

  function initAll() {
    document.querySelectorAll(TRACK_SELECTOR).forEach((track) => {
      syncMarqueeTrack(track);
    });
  }

  function initInnerHeaderMarquee() {
    const track = document.querySelector(
      '.header__sticky-shipping .shipping-marquee-inline__track--animated'
    );
    return syncMarqueeTrack(track);
  }

  let resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      document.querySelectorAll(TRACK_SELECTOR).forEach((track) => {
        delete track.dataset.marqueeInitialized;
        syncMarqueeTrack(track, { force: true });
      });
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', initAll);

  window.BirtzShippingMarquee = { initAll, syncMarqueeTrack, initInnerHeaderMarquee };
})();
